import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ExportButton, TopToolbar, useResourceContext } from "react-admin";
import { NestedList } from "$components/NestedList/NestedList";
import { CoinLevelsListData } from "$components/Entities/CoinLevels/CoinLevelsListData";
import { exportNestedList } from "$components/List/ListActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
const CoinGroupChallenges = (props) => {
    const resourceName = useResourceContext();
    return (_jsx(NestedList, { searchField: "name", subCollection: "CoinGroupChallenges", actions: _jsx(TopToolbar, { children: _jsx(ExportButton, {}) }), resource: "CoinLeaderboards", empty: _jsx(CardContent, { children: _jsx(Typography, { children: "Choose the coin tracker period" }) }), ...props, exporter: exportNestedList("CoinLeaderboardsCoinGroupChallenges"), children: _jsx(CoinLevelsListData, { model: "CoinGroupChallenges", resourceName: resourceName }) }));
};
export { CoinGroupChallenges };
